export default {
  priv: 'pr_intervention',
  overviewTitle: 'Interventiepersonen',
  detailTitle: 'Interventiepersoon',
  deleteTitle: 'deze persoon',
  url: '/references/interventionpersons',
  apiUrl: '/interventionpersons/',
  sortBy: ['name'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'interventionpersons',
  quickFilter: {
    text: 'Zoek op naam',
    value: 'name',
    type: 'text'
  },
  tableFields: [
    {
      text: 'Naam',
      value: 'name',
      link: '/references/interventionpersons/{id}',
      width: '90%'
    }
  ]
};
